export type FrontendTelemetryEventName =
  | "app_loaded"
  | "client_error"
  | "contact_save_failed"
  | "contact_save_started"
  | "contact_save_succeeded"
  | "contact_verification_failed"
  | "contact_verification_succeeded"
  | "faq_viewed"
  | "help_opened"
  | "manual_activity_triggered"
  | "preferences_save_failed"
  | "preferences_save_started"
  | "preferences_save_succeeded"
  | "privacy_disclosure_accepted"
  | "recent_activities_loaded"
  | "strava_link_clicked"
  | "waitlist_submitted";

type TelemetryAttribute = string | number | boolean;

const ALLOWED_ATTRIBUTES = new Set([
  "aspect_ratio",
  "delivery_channel",
  "duration_ms",
  "frontend_metric_name",
  "map_provider",
  "page",
  "reason_code",
  "status"
]);
const ALLOWED_FRONTEND_METRICS = new Set(["configuration_load_ms"]);

export async function track(
  eventName: FrontendTelemetryEventName,
  attributes: Record<string, TelemetryAttribute> = {}
): Promise<void> {
  try {
    const safeAttributes = Object.fromEntries(
      Object.entries(attributes).filter(([key]) => ALLOWED_ATTRIBUTES.has(key))
    );
    await fetch("/api/telemetry", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ event_name: eventName, attributes: safeAttributes }),
      keepalive: true
    });
  } catch {
    if (import.meta.env.DEV) {
      console.debug("Telemetry event was not sent", eventName);
    }
  }
}

export async function trackPerformance(metricName: string, valueMs: number): Promise<void> {
  if (!ALLOWED_FRONTEND_METRICS.has(metricName) || !Number.isFinite(valueMs) || valueMs < 0) {
    await track("client_error", { reason_code: "invalid_frontend_metric" });
    return;
  }
  await track("app_loaded", {
    frontend_metric_name: metricName,
    duration_ms: Math.round(valueMs)
  });
}
